var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevhub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;stroke:#48454a;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.284px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15,
    height: 15,
    transform: "translate(988 257)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-988 -257)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(988.524 257.823)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.321,7.222a2.083,2.083,0,0,1-2.095-1.047,2.054,2.054,0,0,1,.157-2.3A7.134,7.134,0,0,0,10.66,2.3,2.088,2.088,0,0,1,8.722,3.556,2.055,2.055,0,0,1,6.785,2.247,6.434,6.434,0,0,0,4.061,3.818a2.159,2.159,0,0,1-1.99,3.4,8.086,8.086,0,0,0-.209,1.571,5.178,5.178,0,0,0,.209,1.571,2.083,2.083,0,0,1,2.095,1.047,2.054,2.054,0,0,1-.157,2.3,7.134,7.134,0,0,0,2.723,1.571A2.134,2.134,0,0,1,8.67,13.978a2.055,2.055,0,0,1,1.938,1.309,6.434,6.434,0,0,0,2.723-1.571,2.154,2.154,0,0,1-.157-2.3,2.128,2.128,0,0,1,2.095-1.047,8.086,8.086,0,0,0,.209-1.571A3.929,3.929,0,0,0,15.321,7.222Z",
    transform: "translate(-1.861 -2.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.706,8.345,5.135,9.916l1.571,1.571",
    transform: "translate(-2.464 -3.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.48,8.345l1.571,1.571L13.48,11.487",
    transform: "translate(-4 -3.369)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 2.095,
    y2: 4.19,
    transform: "translate(5.813 4.452)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevhub);
export default __webpack_public_path__ + "static/media/devhub.7f43345faa9b0634bd5ca196eba792a3.svg";
export { ForwardRef as ReactComponent };